module.exports = __webpack_public_path__ + "static/media/search.cfd1a895.svg";